import { NumberInput } from "@certa/catalyst/components/Inputs";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";

type NumberFilterProps = {
  isInteger?: boolean;
};

const NumberFilter = (props: NumberFilterProps) => {
  const { isInteger } = props;

  const { handleSearch, label, searchValue, setSearchValue } =
    useFilterOverlay();

  return (
    <NumberInput
      label={label}
      value={searchValue}
      onChange={value => {
        if (value !== undefined) {
          setSearchValue(value);
        }
      }}
      onKeyDown={e => {
        if (e.key === "Enter") {
          handleSearch();
        }
      }}
      placeholder={`Search By ${label}...`}
      isInteger={isInteger}
    />
  );
};

export { NumberFilter };
